import { SITE } from "@/constants/testIds";
import { Check, Clock, Users, Wrench, MapPin, Calendar } from "lucide-react";

const includes = [
  { icon: Clock, label: "2 hours per session" },
  { icon: Users, label: "1–3 students" },
  { icon: Wrench, label: "Equipment provided" },
  { icon: MapPin, label: "Park lawn near the river" },
  { icon: Calendar, label: "Flexible scheduling" },
];

const bring = ["Eye protection", "A smile", "Cash or check"];

export default function Lessons() {
  return (
    <section
      id="lessons"
      data-testid={SITE.lessons}
      className="relative bg-brand-cream py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid items-start gap-14 md:grid-cols-12 md:gap-20">
          <div className="md:col-span-5">
            <span className="text-xs uppercase tracking-[0.35em] text-brand-evergreen/60">
              Lessons
            </span>
            <h2 className="mt-3 font-display text-4xl leading-tight text-brand-evergreen sm:text-5xl lg:text-6xl">
              Personalized fly casting lessons
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-brand-charcoal/75">
              Whether you&rsquo;re brand new to fly fishing, looking to refine your
              technique, or simply searching for a relaxing outdoor
              experience — every lesson is shaped around you. We move at your
              pace, on a quiet stretch of grass beside the river.
            </p>
            <p className="mt-4 text-base leading-relaxed text-brand-charcoal/60">
              Times and locations will be arranged mutually.
            </p>
          </div>

          <div className="md:col-span-7">
            <article
              data-testid={SITE.lessonsPricingCard}
              className="relative overflow-hidden rounded-3xl bg-white p-10 shadow-[0_25px_60px_-30px_rgba(35,66,53,0.35)] ring-1 ring-brand-evergreen/10 md:p-12"
            >
              <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-brand-sand/40 blur-2xl" />
              <div className="relative">
                <div className="flex items-baseline justify-between gap-6">
                  <h3 className="font-display text-3xl text-brand-evergreen sm:text-4xl">
                    Private Lessons
                  </h3>
                  <div className="text-right">
                    <div className="font-display text-5xl text-brand-evergreen sm:text-6xl">
                      $60
                    </div>
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-charcoal/50">
                      per lesson
                    </div>
                  </div>
                </div>

                <div className="my-8 h-px bg-gradient-to-r from-transparent via-brand-evergreen/15 to-transparent" />

                <ul className="grid gap-3 sm:grid-cols-2">
                  {includes.map(({ icon: Icon, label }) => (
                    <li key={label} className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-evergreen/10 text-brand-evergreen">
                        <Icon className="h-4 w-4" />
                      </span>
                      <span className="text-sm text-brand-charcoal/85">
                        {label}
                      </span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 rounded-2xl bg-brand-sand/30 p-5">
                  <div className="text-xs uppercase tracking-[0.25em] text-brand-evergreen/70">
                    Bring with you
                  </div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {bring.map((b) => (
                      <span
                        key={b}
                        className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs text-brand-charcoal/80 ring-1 ring-brand-evergreen/10"
                      >
                        <Check className="h-3 w-3 text-brand-forest" />
                        {b}
                      </span>
                    ))}
                  </div>
                </div>

                <a
                  data-testid={SITE.lessonsCta}
                  href="#contact"
                  className="mt-9 inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-evergreen px-7 py-4 text-sm font-medium tracking-wide text-brand-cream transition-all duration-300 hover:bg-brand-sand hover:text-brand-evergreen sm:w-auto"
                >
                  Request a Session
                  <span aria-hidden>→</span>
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
